import React, { useCallback, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Download, LifeBuoy } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { HelpDeskTickets } from '../components/AdminSupportRequestsTab';
import { useAuth } from '../contexts/AuthContext';

const csvCell = (v) => `"${String(v ?? '').replace(/"/g, '""')}"`;

const exportCsv = (rows) => {
  const head = ['Ticket', 'Status', 'Created', 'Closed', 'Closed By', 'Participant', 'Participant ID', 'Topic', 'Contact Method', 'Contact', 'Message', 'Replies'];
  const lines = rows.map((r) => [r.number, r.status === 'open' ? 'Open' : 'Resolved/Closed', r.created_at, r.resolved_at, r.resolved_by_name, r.participant_name,
    r.participant_id, r.topic, r.contact_method, r.contact_value, r.message, r.replies.length].map(csvCell).join(','));
  const url = URL.createObjectURL(new Blob([[head.join(','), ...lines].join('\n')], { type: 'text/csv' }));
  const a = document.createElement('a');
  a.href = url; a.download = `help-desk-tickets-${new Date().toISOString().slice(0, 10)}.csv`; document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};

const Stat = ({ label, value, testId }) => (
  <Card><CardContent className="p-4"><div className="text-2xl font-bold" data-testid={testId}>{value}</div><div className="text-xs text-muted-foreground">{label}</div></CardContent></Card>
);

export default function HelpDeskTicketsReportPage() {
  const { user } = useAuth();
  const [data, setData] = useState(null);
  const onData = useCallback((d) => setData(d), []);
  if (user?.role !== 'system_admin') {
    return <div className="p-6 text-muted-foreground" data-testid="helpdesk-report-forbidden">Only System Administrators can view Help Desk Tickets.</div>;
  }
  const reqs = data?.requests || [];
  const open = reqs.filter((r) => r.status === 'open').length;
  return (
    <div className="space-y-6" data-testid="helpdesk-tickets-report-page">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <Link to="/reports" className="text-sm text-muted-foreground inline-flex items-center gap-1 hover:text-foreground"><ArrowLeft className="h-4 w-4" />Reports</Link>
          <h1 className="text-2xl font-bold flex items-center gap-2 mt-1"><LifeBuoy className="h-6 w-6" />Help Desk Tickets</h1>
          <p className="text-sm text-muted-foreground">Every HELPConnect support ticket, open or closed.</p>
        </div>
        <Button variant="outline" onClick={() => exportCsv(reqs)} disabled={!reqs.length} data-testid="helpdesk-export-csv"><Download className="h-4 w-4 mr-2" />Export CSV</Button>
      </div>
      <div className="grid grid-cols-3 gap-4">
        <Stat label="Total tickets" value={reqs.length} testId="helpdesk-stat-total" />
        <Stat label="Open" value={open} testId="helpdesk-stat-open" />
        <Stat label="Resolved / Closed" value={reqs.length - open} testId="helpdesk-stat-closed" />
      </div>
      <HelpDeskTickets showSettings={false} defaultFilter="all" onData={onData} />
    </div>
  );
}
